import * as React from 'react';
import { alpha } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { Box } from '@mui/system';

export interface IndexTableToolbarProps {
  numSelected: number;
  title: string;
  total?: number;
}

export const IndexTableToolbar = (props: IndexTableToolbarProps) => {
  const { numSelected, title, total = 0 } = props;

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: theme =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity
            ),
        }),
      }}
    >
      <Box sx={{ flex: '1 1 100%' }}>
        <Typography
          // sx={{ fontWeight: 'bold' }}
          variant="h5"
          id="tableTitle"
          component="div"
        >
          {title}
        </Typography>
        {numSelected > 0 ? (
          <Typography
            // sx={{ flex: '1 1 100%' }}
            color="inherit"
            variant="subtitle2"
            component="div"
          >
            {numSelected} selected
          </Typography>
        ) : (
          <Typography
            // sx={{ flex: '1 1 100%' }}
            variant="subtitle2"
            id="tablesubtitle"
            component="div"
          >
            Total {total}
          </Typography>
        )}
      </Box>
      <Box>
        {numSelected > 0 ? (
          <Tooltip title="Delete">
            <IconButton>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="Filter list">
            <IconButton>
              <FilterListIcon />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Toolbar>
  );
};
